import ImageBrowser from './ImageBrowser';

export default ImageBrowser;
